import * as React from "react";
import { OEEHistory } from "../api/dataTypes";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import * as TableStyles from "../styles/TableFormats";
import "../styles/Tables.css";
import moment from 'moment';
import matchSorter from 'match-sorter';

interface State {

}

export interface Props {
    records: OEEHistory[] | null;
    loading: boolean;
}

export class OEERecordsTable extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="component-standard">
                <div className="ReactTable">
                    <div className="row" style={{ 'marginRight': '-22px' }}>
                        <div className="col-6 col-sm-10 label-large text-dark-blue">
                            Daily OEE Reports:
                        </div>
                    </div>
                    <ReactTable
                        data={this.props.records || undefined}
                        defaultFilterMethod={(filter, row) => (matchSorter([row[filter.id]], filter.value).length !== 0)}

                        // COLUMNS ////////////////////////////////
                        columns={[{
                            Header: 'Run Time',
                            accessor: 'runTime',
                            headerStyle: TableStyles.columnHeaderStyle,
                            style: TableStyles.dataStyle,
                            // width: 300
                        }, {
                            Header: 'Idle Time',
                            accessor: 'idleTime',
                            headerStyle: TableStyles.columnHeaderStyle,
                            style: TableStyles.dataStyle,
                            // width: 300
                        }, {
                            Header: 'Utilization',
                            id: 'utilization',
                            headerStyle: TableStyles.columnHeaderStyle,
                            style: TableStyles.dataStyle,
                            // width: 300
                            accessor: (a: OEEHistory) => {
                                return (`${(100 * a.runTime / (a.runTime + a.idleTime)).toFixed()}%`)
                            }
                        }, {
                            Header: 'Cycle Count',
                            accessor: 'cycleCount',
                            headerStyle: TableStyles.columnHeaderStyle,
                            style: TableStyles.dataStyle,
                            // width: 300
                        }, {
                            Header: 'Cut Length (ft)',
                            id: 'cutLengthTotal',
                            accessor: row => Math.round(row.cutLengthTotal * 100) / 100,
                            headerStyle: TableStyles.columnHeaderStyle,
                            style: TableStyles.dataStyle,
                            // width: 300
                        }, {
                            Header: 'Start Time',
                            id: 'startTime',
                            accessor: row => moment(row.startTime).format('x'),
                            Cell: row => (moment(row.original.startTime).format(' hh:mm:ss a, MM/DD/YY')),
                            headerStyle: TableStyles.columnHeaderStyle,
                            style: TableStyles.dataStyle,
                            width: 225,
                        }, {
                            Header: 'End Time',
                            id: 'endTime',
                            accessor: row => moment(row.endTime).format('x'),
                            Cell: row => (moment(row.original.endTime).format(' hh:mm:ss a, MM/DD/YY')),
                            headerStyle: TableStyles.columnHeaderStyle,
                            style: TableStyles.dataStyle,
                            width: 225
                        },
                        ]}
                        // COLUMNS END //////////////////
                        defaultSorted={[{ id: 'startTime', desc: true }]}
                        className="-highlight"
                        // showPagination={false}
                        minRows={10}
                        loading={this.props.loading}
                    />
                </div>
            </div>
        );
    }

}